var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2508 2.35274L19.3853 0.487305L17.5199 2.35274L15.6544 0.487305L13.789 2.35274L11.9236 0.487305L10.0581 2.35274L8.1927 0.487305L6.32727 2.35274L4.46183 0.487305L2.59639 2.35274L0.730957 0.487305V25.3598L2.59639 23.4944L4.46183 25.3598L6.32727 23.4944L8.1927 25.3598L10.0581 23.4944L11.9236 25.3598L13.789 23.4944L15.6544 25.3598L17.5199 23.4944L19.3853 25.3598L21.2508 23.4944L23.1162 25.3598V0.487305L21.2508 2.35274ZM20.6289 21.7408H3.21821V4.10625H20.6289V21.7408ZM4.46183 16.6544H19.3853V19.1417H4.46183V16.6544ZM4.46183 11.6799H19.3853V14.1672H4.46183V11.6799ZM4.46183 6.70543H19.3853V9.19267H4.46183V6.70543Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceNumber);
export default __webpack_public_path__ + "static/media/invoice_number.5ab50aee858a1adb8196a0107def1f3e.svg";
export { ForwardRef as ReactComponent };